import * as Yup from "yup";
export type examScheduleType = {
  college_ids: string[];
  class_ids: string;
  start_date: string;
  end_date: string;
  scheduled_exam_type_id: string;
  scheduled_exam_name: string;
};

export const examScheduleInitialValuesFilter: examScheduleType = {
   college_ids: [],
  class_ids:"",
  start_date: "",
  end_date: "",
  scheduled_exam_type_id: "",
  scheduled_exam_name: "",
};

export const examScheduleMandatoryFields = [
];

export const examScheduleValidationSchemaFilter = Yup.object().shape({});

export const examSchedulePropertiesFilter = [
  {
    id: "college_ids",
    type: "multi-select-dependency",
    label: "College",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    isDependent: true,
    options: [],
    list: "college_list_gqf",
    dependencyLabel: "Please select State",
    keyValue: { label: "name", value: "id" },
    fieldKeyLists: {},
  },
  {
    id: "class_ids",
    type: "single-select-dependency",
    label: "Class",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    options: [],
    required: true,
    list: "class_list_gqf",
    keyValue: { label: "name", value: "id" },
    dependentFields: [""],
    dependentFlds: {
      class_course_batch_data: "class_list_gqf",
    },
  },
  {
    id: "start_date",
    type: "date-picker",
    label: "Schedule Date",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    required: false,
  },
  {
      id: "scheduled_exam_type_id",
      type: "normal-select",
      label: "Exam Type",
      className: "select-styles",
      breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
      required: true,
      options: [],
      list: "exam_type_gqf",
      keyValue: { label: "name", value: "id" },
    },
     {
      id: "scheduled_exam_name",
      type: "text",
      label: `Exam Name`,
      className: "name-styles",
      breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
      required: false,
    },
];
